import React from "react";
import {
  Card,
  Table,
  Badge,
  Spinner,
} from "react-bootstrap";

import {
  FiUser,
  FiPhone,
  FiMapPin,
  FiEdit2,
  FiTrash2,
} from "react-icons/fi";

import styles from "./SupplierPartyTable.module.css";
import CommonActionMenu from "../../Common/CommonAction/CommonActionMenu";

const SupplierPartyTable = ({
  data = [],
  onEdit,
  onDelete,
  loading = false,
}) => {
  return (
    <Card className={styles.mainCard}>
      <Card.Body className={styles.cardBody}>
        {/* LOADER */}
        {loading ? (
          <div className={styles.loaderContainer}>
            <Spinner
              animation="border"
              variant="primary"
              className={styles.loader}
            />

            <div className={styles.loadingText}>
              Loading supplier parties...
            </div>
          </div>
        ) : (
          <div className={styles.tableWrapper}>
            <Table responsive borderless hover className="mb-0">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Contact</th>
                  <th>City</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                {data?.length > 0 ? (
                  data?.map((item, index) => (
                    <tr
                      key={item._id || index}
                      className={`${styles.row} ${
                        index % 2 === 0
                          ? styles.evenRow
                          : styles.oddRow
                      }`}
                    >
                      {/* NAME */}
                      <td>
                        <div className={styles.nameBox}>
                          <div className={styles.avatar}>
                            <FiUser />
                          </div>

                          <div>
                            <div className={styles.name}>
                              {item.name}
                            </div>

                            <div className={styles.subText}>
                              {item.email_id || "No Email"}
                            </div>
                          </div>
                        </div>
                      </td>

                      {/* CONTACT */}
                      <td>
                        <div className={styles.contact}>
                          <div>
                            <FiPhone /> {item.mobile || "NA"}
                          </div>

                          <div className={styles.whatsapp}>
                            WA: {item?.whatsapp || "NA"}
                          </div>
                        </div>
                      </td>

                      {/* CITY */}
                      <td>
                        <div className={styles.city}>
                          <FiMapPin /> {item.city || "NA"}
                        </div>
                      </td>

                      {/* STATUS */}
                      <td>
                        <Badge
                          bg={
                            item.is_active
                              ? "success"
                              : "secondary"
                          }
                          className={styles.statusBadge}
                        >
                          {item.is_active
                            ? "Active"
                            : "Inactive"}
                        </Badge>
                      </td>

                      {/* ACTION */}
                      <td className={styles.actionCell}>
                        <CommonActionMenu
                          actions={[
                            {
                              label: "Edit",
                              icon: <FiEdit2 />,
                              onClick: () =>
                                onEdit?.(item),
                            },
                            {
                              label: "Delete",
                              icon: <FiTrash2 />,
                              danger: true,
                              onClick: () =>
                                onDelete?.(item),
                            },
                          ]}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className={styles.emptyState}
                    >
                      No supplier party found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

export default SupplierPartyTable;